import firebase from "firebase";
import firebaseui from "firebaseui";
import Spinner from "vue-simple-spinner";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "SignupForm",
  components: {
    Spinner
  },
  mounted() {
    const uiConfig = {
      callbacks: {
        // Called when the user has been successfully signed in.
        signInSuccessWithAuthResult: function(authResult, redirectUrl) {
          return false;
        }
      },
      signInFlow: "popup",
      credentialHelper: firebaseui.auth.CredentialHelper.NONE,
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.PhoneAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID
      ]
    };
    const ui = new firebaseui.auth.AuthUI(firebase.auth());
    ui.start("#firebaseui-auth-container", uiConfig);

    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.currentUser = JSON.parse(JSON.stringify(user));
        console.log("does user exist dispatch");
        this.dispatchDoesUserExist(this.currentUser);
      } else {
        // TODO- handle error message
      }
    });
  },
  computed: {
    ...mapGetters(["isNewUser", "isAuthInProgress"])
  },
  watch: {
    isNewUser(newData, oldData) {
      console.log("triggered new user");
      if (newData === true) {
        this.step = 1;
      } else {
        this.$router.push("/dashboard");
      }
    }
  },
  data() {
    return {
      step: 0,
      currentUser: null,
      zipCode: null
    };
  },
  methods: {
    ...mapActions(["dispatchCreateUser", "dispatchDoesUserExist"]),

    addZip() {
      // add a null case for zipcode
      const sendObj = {
        currentUser: this.currentUser,
        zipCode: this.zipCode
      };
      console.log("creating user... ");
      this.dispatchCreateUser(sendObj);
      this.$router.push("/dashboard");
    }
  }
};
